import { FetchBaseQueryError } from '@reduxjs/toolkit/query/react'

import { getFirebase } from '~/firebase'

import { BootcampActivityEventId, LevelActionType } from '~/bootcamp/types/bootcamp.types'

import { bootcampSplitApi } from './split.api'

const GetList = bootcampSplitApi.injectEndpoints({
  endpoints: (build) => ({
    getBootcampActivityEventIdsList: build.query<
      BootcampActivityEventId[],
      { bootcampKey: string; moduleKey: string; level: string; activityType: number }
    >({
      queryFn: async ({ bootcampKey, moduleKey, level, activityType }) => {
        try {
          const { fireStore, query, getDocs, auth, collection, where } = await getFirebase()
          const userId = auth.currentUser?.uid

          if (!userId) {
            return { data: [] }
          }

          const resp = await getDocs(
            query(
              collection(fireStore, 'bootcamp', String(userId), 'events'),
              where('bootcampId', '==', bootcampKey),
              where('moduleId', '==', moduleKey),
              where('levelId', '==', level),
              where('levelPage', '==', LevelActionType.Activity),
              where('type', '==', activityType),
            ),
          )

          return {
            data: resp.docs.map((elem) => elem.id) as BootcampActivityEventId[],
          }
        } catch (error) {
          return {
            error: error as FetchBaseQueryError,
          }
        }
      },
      providesTags: ['ActivityData'],
    }),
  }),
  overrideExisting: false,
})

export const { useGetBootcampActivityEventIdsListQuery } = GetList
